import React, { FunctionComponent } from 'react';

import { PageContainer } from 'containers/page/page-container';

import { FooterContainer } from '../common/app/footer-container';
import { HeaderContainer } from '../common/app/header-container';
import { AboutCeoContainer } from './about-ceo-container';
import { AboutHeroBlockContainer } from './about-hero-block-container';
import { AboutIntroContainer } from './about-intro-container';
import { AboutMissionContainer } from './about-mission-container';
import { AboutOurStoryContainer } from './about-our-story-container';
import { AboutWorkWithUsContainer } from './about-work-with-us-container';

export const AboutContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1} className="project-love-main">
        <AboutHeroBlockContainer />
        <AboutIntroContainer />
        <AboutOurStoryContainer />
        <AboutMissionContainer />
        <AboutCeoContainer />
        <AboutWorkWithUsContainer />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
